import { fromJS } from 'immutable';
import { getIn } from '@client/shared/utils/immutableUtils/immutableUtils';
import { getTranslations } from './I18N_KEYS';

export const I18N_REDUCER_KEY = 'i18nReducer';

export const LOAD_TRANSLATIONS = 'LOAD_TRANSLATIONS';

let defaultState = fromJS({
  translations: {},
  errorMessage: null,
});

export default function(state = defaultState, action = {}) {
  switch (action.type) {
    case LOAD_TRANSLATIONS: {
      return state.merge({
        translations: fromJS(action.payload),
        errorMessage: null,
      });
    }
    default:
      return state;
  }
}

export function loadTranslations(lang = 'se') {
  const translations = getTranslations(lang);

  return {
    type: LOAD_TRANSLATIONS,
    payload: translations,
  };
}

export const selectTranslations = (state) => {
  return getIn(state[I18N_REDUCER_KEY], 'translations');
};
